// extracted by mini-css-extract-plugin
module.exports = {"Group":"Radio_Group__HdD_4","Radio":"Radio_Radio__tWBTy","Indicator":"Radio_Indicator___o3aw","icon":"Radio_icon__2yF8S","label":"Radio_label__9348o"};